// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg height=24px viewBox=\"0 -960 960 960\" width=24px fill=#000000><path d=\"M366.15-253.85 140-480l226.15-226.15L408.31-664l-154 154H760v-160h60v220H254.31l154 154-42.16 42.15Z\"/></svg>";
// Exports
module.exports = code;